<template>
    <v-row>
        <v-col cols="6" v-for="(file, index) in files" v-if="videoCheck(file.name, file.type)">
            <v-row>
                <v-col cols="12">
                    <video v-if="file.file.indexOf('https://fit-service-bitrix') > -1" :src="file.file" controls></video>
                    <video v-else :src="`https://sbotapi.fitauto.ru/v15/shopper/media/${file.deal_id}/${file.name}`" controls></video>
                </v-col>
                <v-col cols="12">
                    <v-btn icon small title="Скачать" :href="file.file" class="mr-2"><v-icon small>mdi-download</v-icon></v-btn>
                    {{ file.name }}
                </v-col>
            </v-row>

        </v-col>
        <v-col cols="12" v-if="!showUK && stage === 'C30:1'">
            <v-row>
                <v-col cols="4"><v-file-input accept="video/mp4" :rules="rules" v-model="newVideoFile" placeholder="Загрузить видео"></v-file-input></v-col>
                <v-col cols="4"><v-btn color="success" :disabled="newVideoFile === null || newVideoFile.length < 1" @click="loadVideo">Загрузить</v-btn></v-col>
            </v-row>
        </v-col>

        <v-col cols="12">Всего видео файлов: {{ videoCount }}</v-col>
        <simple-loader-dialog text="Загрузка. Ожидайте" :show="showLoader"></simple-loader-dialog>
    </v-row>
</template>

<script>
    import moment from 'moment'
    import SimpleLoaderDialog from '../simpleLoaderDialog'
  export default {
    name: 'videoCard',
    components: { SimpleLoaderDialog },
    props: ['value', 'mode', 'stage'],
    data() {
      return {
        showLoader: false,
        newVideoFile: null,
        rules: [
          value => !value || value.size < 50000000 || 'Размер файла не должен превышать 50Мб',
        ],
        files: this.value
      }
    },
    computed: {
      showUK() {
        return this.mode === 'uk'
      },
      videoCount() {
        let video = ['mp4', 'avi', 'mov']
        if(this.files) {
          let filez =  this.files.filter(f => {
            let fname = f.name.split('.')
            let sname = fname[fname.length - 1].toLowerCase()
            return video.indexOf(sname) > -1 || f.type === 'video'
          })
          return filez.length
        } else {
          return 0
        }
      },
    },
    methods: {
      loadVideo: async function() {
        let data = this.newVideoFile
        let formData = new FormData()
        let uploadURL, field

        this.showLoader = true
        try {
          const r = await this.$http.post(`${this.$store.getters.bxapi}disk.folder.uploadfile?id=80614`)
          if(r.data.result) {
            uploadURL = r.data.result.uploadUrl
            field = r.data.result.field
            formData.append(field, this.newVideoFile, `${moment().format('x')}${this.newVideoFile.name}`)
          }
        } catch (e) {
          console.log('e')
        }

        if(field !== undefined) {
          try {
            const r = await this.$http.post(uploadURL,
              formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }
            )
            this.files.push({
              file: r.data.result.DOWNLOAD_URL,
              name: r.data.result.NAME,
              type: 'audio',
              itemKey: `${this.files.length}_${moment().format('x')}`
            })
          } catch (e) {
            console.log(e)
          }
        }
        this.newVideoFile = null
        this.showLoader = false
        this.change()
      },
      videoCheck(filename, type) {
        let types = ['mp4', 'avi', 'mov']
        let fname = filename.split('.')
        let sname = fname[fname.length - 1].toLowerCase()
        return (types.indexOf(sname) > -1 || type === 'video')
      },
      change() {
        this.$emit('input', this.files)
        this.$nextTick(function () {
          this.$emit('change')
        })
      }
    }
  }
</script>

<style scoped>

</style>
